import { dataTruckSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTruckSolid = /*#__PURE__*/createIcon(dataTruckSolid)
export default IconTruckSolid
